import { updatesCtrl } from '../admin/modals';
import { TerminalCommandModal } from '../admin/terminal-command-modal.component';
import { DebugInfoModal } from '../admin/debug-info-modal.component';

require('./header.component.scss');

class HeaderController {
  constructor(
    $scope,
    CurrentFilterService,
    CurrentModelService,
    $rootScope,
    PermissionService,
    RouterService,
    $cookies,
    $modal,
    FilterEditorService,
    $http,
    CurrentFilterDataService,
    $q,
    FiltersService,
  ) {
    this.$scope = $scope;
    this.currentFilter = CurrentFilterService;
    this.filterBar = CurrentFilterService.filterBar;
    this.CurrentModelService = CurrentModelService;
    this.$rootScope = $rootScope;
    this.permission = PermissionService;
    this.router = RouterService;
    this.langClasses = {
      'ru': 'flag-icon-ru',
      'en': 'flag-icon-gb',
      'cn': 'flag-icon-cn',
    };
    this.selectedLang = $cookies.get('django_language') || window.selectedLang;
    this.$modal = $modal;
    this.$cookies = $cookies;
    this.FilterEditorService = FilterEditorService;
    this.$http = $http;
    this.CurrentFilterDataService = CurrentFilterDataService;
    this.$q = $q;
    this.FiltersService = FiltersService;
    this.CurrentFilterService = CurrentFilterService;
  }

  get model() {
    return this.CurrentModelService.model;
  }

  get filter() {
    return this.currentFilter.filter;
  }

  set filter(filter) {
    this.currentFilter.filter = filter;
  }

  reset() {
    this.router.resetFilter();
  }

  debugInfo() {
    this.$modal.open({
      template  : require('../admin/debug-info-modal.component.html'),
      controller: DebugInfoModal,
      scope     : this.$scope,
    }).result
      .catch((err) => {
        console.error(err);
      });
  }

  terminalCommand(terminalCommandValue, commandText) {
    this.$modal.open({
      template  : require('../admin/terminal-command-modal.component.html'),
      controller: TerminalCommandModal,
      scope     : this.$scope,
      resolve   : {
        command    : () => terminalCommandValue,
        commandText: () => commandText,
      },
    }).result
      .catch((err) => {
        console.error(err);
      });
  }

  saveFilter(asNew) {
    this.FilterEditorService.saveFilter(asNew);
  }

  editFilter() {
    this.FilterEditorService.editModal({
      filter: this.CurrentFilterService.filter,
      asNew: false,
      selectFilter: true,
    });
  }

  updateServer() {
    this.$modal.open({
      templateUrl: 'updatesDialog.html',
      controller : updatesCtrl,
    })
      .result
      .then(result => {
        //console.log(result);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  selectLang(lang) {
    if (lang !== this.$cookies.get('django_language')) {
      const expires = new Date();
      expires.setFullYear(expires.getFullYear() + 100);
      this.$cookies.put('django_language', lang, {
        expires: expires
      });
      location.reload();
    }
  }

  newFilter() {
    this.router.newFilter();
  }

  viewReport() {
    this.router.panel = 'catalog';
    this.$rootScope.$broadcast('resize');
  }
}

export const HeaderComponent = {
  template  : require('./header.component.html'),
  controller: HeaderController,
};



// WEBPACK FOOTER //
// ./src/layout/header.component.js